import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getSimulatedEarningsPageData } from "./common/service";

export function simulatedEarningsLoader() {
  return defer({
    coreData: resolveLoaderResult(getSimulatedEarningsPageData()),
  });
}
